export class DivWithDivider extends HTMLElement {
  private _prefixDiv: HTMLDivElement;
  private _suffixDiv: HTMLDivElement;
  private _intSlot: HTMLSlotElement;

  private _hasChildren = false;
  private _shouldShowPrefix = true;
  private _shouldShowSuffix = true;

  constructor() {
    super();

    this._intSlot = document.createElement("slot");
    this._intSlot.setAttribute("part", "part-body");

    this._intSlot.setAttribute("exportparts", "smart-table-search-box");

    this._prefixDiv = document.createElement("div");
    this._prefixDiv.setAttribute("part", "part-prefix");
    this._prefixDiv.style.order = "-1";

    this._suffixDiv = document.createElement("div");
    this._suffixDiv.setAttribute("part", "part-suffix");
    this._suffixDiv.style.order = "100";
  }

  connectedCallback() {
    const root = this.attachShadow({ mode: "open" });

    root.appendChild(this._prefixDiv);
    root.appendChild(this._intSlot);
    root.appendChild(this._suffixDiv);

    this.hasChildren = this._intSlot.assignedElements().length > 0;

    this._intSlot.addEventListener("slotchange", () => {
      this.hasChildren = this._intSlot.assignedElements().length > 0;
    });
  }

  get hasChildren() {
    return this._hasChildren;
  }

  set hasChildren(v: boolean) {
    this._hasChildren = v;
    this._updateVisibility();
  }

  get showPrefix(): boolean {
    return this._shouldShowPrefix;
  }

  set showPrefix(v: boolean) {
    this._shouldShowPrefix = v;
    this._prefixDiv.style.display = v && this._hasChildren ? "block" : "none";
  }

  get showSuffix(): boolean {
    return this._shouldShowSuffix;
  }

  set showSuffix(v: boolean) {
    this._shouldShowSuffix = v;
    this._suffixDiv.style.display = v && this._hasChildren ? "block" : "none";
  }

  _updateVisibility() {
    this._prefixDiv.style.display =
      this._shouldShowPrefix && this._hasChildren ? "block" : "none";

    this._suffixDiv.style.display =
      this._shouldShowSuffix && this._hasChildren ? "block" : "none";
  }
}

customElements.define("div-divider-element", DivWithDivider);

declare global {
  interface HTMLElementTagNameMap {
    "div-divider-element": DivWithDivider;
  }
}
